import { render, staticRenderFns } from "./FormP10.vue?vue&type=template&id=58c4bde6&scoped=true"
import script from "./FormP10.vue?vue&type=script&lang=ts"
export * from "./FormP10.vue?vue&type=script&lang=ts"
import style0 from "./FormP10.vue?vue&type=style&index=0&id=58c4bde6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c4bde6",
  null
  
)

export default component.exports